import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { useLocation } from 'react-router-dom';

import ManageTemplate from '../../../../page/ManageTemplate/ManageTemplate';
import LoaderContext from '../../../../context/LoaderProvider';
import useToast from '../../../../hooks/useToast';

// Cambiar los step numerales por esto que es mas entendible
const stepsApplyModal = {
  grid: 1,
  confirmApplyModal: 2
};

const ModalApplyTemplate = ({ isDraw, show, setShow, idDraw, applyTemplateRequest }) => {
  const [checkBoxState, setCheckBoxState] = useState([]);
  const [itemCheck, setItemCheck] = useState([]);
  const [modalDeleteHide, setModalDeleteHide] = useState(true);
  const [step, setStep] = useState(1);

  const isInConfimationApplyStep = step === stepsApplyModal.confirmApplyModal;
  const isInGridStep = step === stepsApplyModal.grid;

  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();
  const location = useLocation();

  const closeModal = () => {
    setStep(stepsApplyModal.grid);
    setShow(false);
  };

  const applyTemplate = () => {
    try {
      const idTemplate = itemCheck[0]?.id;

      applyTemplateRequest(idTemplate, true);
      setLoader(true);
      setLoader(false);
      closeModal();
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setLoader(false);
      closeModal();
    }
  };

  const handleOnClickPrimaryAction = () => {
    if (isInGridStep) setStep(stepsApplyModal.confirmApplyModal);
    if (isInConfimationApplyStep) applyTemplate();
  };

  const handleOnClickSecondaryAction = () => {
    if (isInGridStep) closeModal();
    if (isInConfimationApplyStep) setStep(stepsApplyModal.grid);
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={closeModal}
      primaryAction={handleOnClickPrimaryAction}
      primaryActionDisabled={checkBoxState.length !== 1}
      primaryActionLabel="Aplicar plantilla"
      primaryActionVariant="primary"
      secondaryAction={handleOnClickSecondaryAction}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title="Aplicar plantilla"
      variantHeader={modalDeleteHide ? 'info' : 'info hide-modal-template'}
    >
      <div className="d-flex justify-content-center">
        <h6
          style={{
            color: '#3865B8'
          }}
        >
          {isInGridStep ? (
            `Seleccioná una de las plantillas para aplicar los valores
              en la solicitud de servicio.`
          ) : (
            <>
              <p className="fw-bold">
                Se generará la solicitud de servicio a partir de la plantilla.
              </p>
              <p className="fw-bold">
                Para completar la solicitud de servicio es preciso especificar las fechas.
              </p>
            </>
          )}
        </h6>
      </div>
      <hr />
      <ManageTemplate
        applyTemplateView
        checkBoxState={checkBoxState}
        idDraw={idDraw}
        isDraw={isDraw}
        isRequestTemplateView
        itemCheck={itemCheck}
        previusPath={location.pathname}
        setCheckBoxState={setCheckBoxState}
        setItemCheck={setItemCheck}
        setModalDeleteHide={setModalDeleteHide}
        viewWithOutCheckBox={isInConfimationApplyStep}
      />
    </ModalGeneric>
  );
};

ModalApplyTemplate.propTypes = {
  isDraw: PropTypes.bool,
  idDraw: PropTypes.string,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  applyTemplateRequest: PropTypes.func.isRequired
};

ModalApplyTemplate.defaultProps = {
  isDraw: false,
  idDraw: ''
};

export default ModalApplyTemplate;
